import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const PackagesPage = lazy(() =>
  import('@/pages/ads/packages/packages-page').then((m) => ({ default: m.PackagesPage })),
);

export const Route = createFileRoute('/_app/ads/packages')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:apps', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <PackagesPage />
    </Suspense>
  ),
});
